import { render, staticRenderFns } from "./Funnel3DChart.vue?vue&type=template&id=1b02d23c&scoped=true"
import script from "./Funnel3DChart.vue?vue&type=script&lang=js"
export * from "./Funnel3DChart.vue?vue&type=script&lang=js"
import style0 from "./Funnel3DChart.vue?vue&type=style&index=0&id=1b02d23c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b02d23c",
  null
  
)

export default component.exports